var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-action-sheet',{attrs:{"actions":_vm.actions,"close-on-click-action":"","cancel-text":_vm.cancelText,"title":_vm.title},on:{"select":_vm.onSelect},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}})
}
var staticRenderFns = []

export { render, staticRenderFns }